import React, { forwardRef } from 'react';

import { LEVELS, isPhone, ImageUpload, Popup } from '@helpers';
import { View } from 'react-native';
import TableToolsItem from './TableToolsItem';
import { scale } from '@components/frame';
import { TableToolsProps } from './types';

import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';

import AddTool from '@components/tool/components/addTool';
import Part from '@components/globalAdd/modal/Part';
import { IMAGE_UPLOAD_FOOTER_TEXT, IMAGE_UPLOAD_HEADER_TEXT, IMAGE_UPLOAD_MAIN_TEXT, TEST_IDS } from '@v2/pages/common/constants/base.constants';

const TableTools = forwardRef<View | null, TableToolsProps>(
  ({ isTableMode, level, apiRef, isRefReady, style, C, isWithERP, noTools, size = 28, imageUploadConfig }, ref) => {
    const showTableTools = !noTools && isTableMode && !isPhone;

    const toolsData = [
      {
        iconUrl: 'filters',
        onPress: () => apiRef?.current?.showFilterPanel?.(),
      },
    ];

    const showPlus =
      [LEVELS.Tools, LEVELS.NCFiles, LEVELS.ImagesDocuments, LEVELS.DetailsScreenImagesDocuments].includes(level) ||
      (level === LEVELS.Parts && !isWithERP);

    const plusAction = {
      [LEVELS.Tools]: () => {
        Popup({
          Component: (p: any) => (
            <AddTool
              {...{
                ...p,
                showAddTool: true,
                toogleShowAddTool: p.hide,
                rounded: !isPhone,
              }}
            />
          ),
        });
      },
      [LEVELS.NCFiles]: () => {
        ImageUpload({
          withoutAddExisting: true,
          addingNcFile: true,
          noPhoto: true,
          uploadStart: () => {},
          uploadEnd: () => {},
          documentType: 'NcFile',
          tags: [],
          headerText: IMAGE_UPLOAD_HEADER_TEXT.AddNcFile,
          footerText: IMAGE_UPLOAD_FOOTER_TEXT.AddNcFile,
          mainText: IMAGE_UPLOAD_MAIN_TEXT.NcFile,
        });
      },
      [LEVELS.Parts]: () => {
        Popup({
          Component: Part,
          width: 580,
        });
      },
      [LEVELS.ImagesDocuments]: () => {
        ImageUpload({
          uploadStart: () => {},
          uploadEnd: () => {},
          saveToMainStore: false,
          tags: [],
        });
      },
      [LEVELS.DetailsScreenImagesDocuments]: () => {
        ImageUpload({
          uploadStart: () => {},
          uploadEnd: () => {},
          saveToMainStore: false,
          tags: [],
        });
      },
    };

    return (
      <View style={[style]} ref={ref}>
        {isRefReady && showTableTools ? (
          <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: scale(12) }}>
            {toolsData.map((data) => (
              <TableToolsItem style={{ padding: scale(4) }} key={data.iconUrl} {...data} />
            ))}
          </View>
        ) : null}
        {showPlus && (
          <TouchableElement
            testID={level === LEVELS.DetailsScreenImagesDocuments ? TEST_IDS.ncFileDocuments.addButton : undefined}
            onPress={() => {
              if (imageUploadConfig) {
                ImageUpload(imageUploadConfig);
                return;
              }

              if (plusAction[level]) {
                plusAction[level]();
              }
            }}
          >
            {({ boxStyle, pressHoverColor }) => (
              <View
                style={[
                  boxStyle,
                  {
                    backgroundColor: C(pressHoverColor('Button/Light/Primary')),
                    borderRadius: scale(size),
                    height: scale(size),
                    width: scale(size),
                    alignItems: 'center',
                    justifyContent: 'center',
                  },
                ]}
              >
                <View>
                  <Svg icon="plusSmall" width={scale(18)} height={scale(18)} color={'Button/Light/Primary Text'} />
                </View>
              </View>
            )}
          </TouchableElement>
        )}
      </View>
    );
  }
);

export default TableTools;
